import {IPaylodAction} from '../interfaces/dispatchers'
import DataQueriesActions from '../enums/ActionTypes/DataQueriesActions'
import {IDataQueries} from '../interfaces/reducers/IDataQueries'

const initState: IDataQueries = {}

const dataQueries = (state: IDataQueries = initState, action: IPaylodAction) => {
  switch (action.type) {
    case DataQueriesActions.UPDATE_SOURCE_QUERIES:
      return {...state, ...action.payload}
    default:
      return state
  }
}
export default dataQueries
